export * from './artists.component';
export * from './artist-detail/artist-detail.component';
export * from './artist-item/artist-item.component';
export * from './all-artist/all-artist.component';


// WEBPACK FOOTER //
// ./src/app/artists/index.ts